import {
  Box,
  CardMedia,
  Skeleton,
  Typography,
} from "@mui/material";
import { VideoHistoryData } from "../../../../../Types/VideoSuite-Types";
import { memo, useRef, useState } from "react";
import { VideoDetailsView } from "../../../../VideoSuite/Components/Shared/VideoSuiteHelper";
import { getVideoSuiteHistoryAppIcon } from "../../../../VideoSuite/VideoSuiteHistory/Components/VideoSuiteHistoryDetailsModal";
import ExpertexVideo from "../../../../VideoSuite/ExpertexVideo";

interface HandleEvent extends React.MouseEvent<HTMLDivElement> { }

interface VideoSuiteCardProps {
  videoData: VideoHistoryData;
  handleOpenVideoHistoryDetailsModal: (videoId: string) => void;
  showVideoOptions?: { delete: boolean; download: boolean; share: boolean };
  cardView?: number;
}

const VideoLibraryCard = ({
  videoData,
  handleOpenVideoHistoryDetailsModal,
  showVideoOptions = { delete: true, download: true, share: false },
  cardView,
}: VideoSuiteCardProps) => {
  const [videoHover, setVideoHover] = useState(false);
  const [isLoading, setIsLoading] = useState(true);

  const handleMouseEnter = () => {
    setVideoHover(true);
  };

  const handleMouseLeave = () => {
    setVideoHover(false);
  };

  const handleVideoLoaded = () => setIsLoading(false);
  const handleVideoError = () => {
    setIsLoading(false);
    console.error("Error loading video");
  };

  const handleDownload = (e: HandleEvent) => {
    e.stopPropagation();
    if (!videoData.output) return;

    const link = document.createElement("a");
    link.href = videoData.output;
    link.download = "video.mp4";
    link.click();
  };

  const handleOpenModal = () => {
    if (isLoading) return;
    handleOpenVideoHistoryDetailsModal(videoData.id);
  };

  const handleShareVideo = (e: HandleEvent) => {
    e.stopPropagation();
  };

  return (
    <Box
      className={`video-card ${videoHover && !isLoading ? "video-card-hover" : "video-card-not-hover"}`}
      onMouseEnter={handleMouseEnter}
      onMouseLeave={handleMouseLeave}
      onClick={handleOpenModal}
      sx={{ cursor: isLoading ? "not-allowed" : "pointer" }}
    >
      
      <ExpertexVideo
        src={videoData.output}
        onLoadedData={handleVideoLoaded}
        onError={handleVideoError}
        CanPlayOnHover={true}
        hovered={videoHover}
      />

      {videoHover && !isLoading && (
        <Box className="video-hover-overlay">
          <Box className="video-hover-content">
            <Box className="video-hover-actions">
              {showVideoOptions.download && (
                <Box
                  className={`icon-container ${cardView === VideoDetailsView.library && "display-bottom"}`}
                  onClick={handleDownload}
                >
                  <CardMedia
                    component="img"
                    image="/Images/VideoSuite/downloadIcon.svg"
                    className="icon-download-image"
                  />
                </Box>
              )}
            </Box>

            <Box className="video-hover-footer">
              <Box className="video-footer-left">
                <Box className="circle-icon">
                  {getVideoSuiteHistoryAppIcon(videoData.appType)}
                </Box>
                <Typography className="shared-typography" sx={{ color: "#fff" }}>
                  {videoData.appType}
                </Typography>
              </Box>
            </Box>
          </Box>
        </Box>
      )}
    </Box>
  );
};

export default VideoLibraryCard;
